import { render, staticRenderFns } from "./MemberPackageBenefit.vue?vue&type=template&id=52e1778e&scoped=true"
import script from "./MemberPackageBenefit.vue?vue&type=script&lang=js"
export * from "./MemberPackageBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1778e",
  null
  
)

export default component.exports